import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UtilsService} from '../../../core/utils/utils.service';
import {Subscription} from 'rxjs';
import {HELP_FOLDERS} from '../../../core/constants';
import {PopularityHistoryProduct} from "../../../core/models/gestion-produits/popularity/popularity-history-product";
import {ProduitsService} from "../../../core/services/entities/produits.service";

@Component({
  selector: 'yo-popularite-produit',
  templateUrl: './popularite-produit.component.html',
  styleUrls: ['./popularite-produit.component.scss'],
  standalone: false
})
export class PopulariteProduitComponent implements OnInit, OnDestroy {

  subPopularityHistory: Subscription;
  idProduit: number;
  selectedDates: Date[] = []

  pathFile: string = HELP_FOLDERS.PRODUITS + '/popularite';
  popularityHistory: PopularityHistoryProduct[];

  constructor(public utils: UtilsService,
              private router: Router,
              private produitSvc: ProduitsService,
              private utilSvc: UtilsService) {
  }

  ngOnInit(): void {
    this.initDate();
    this.subscriptionRouteData();

  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subPopularityHistory);
  }

  subscriptionRouteData = () => {
    const regex = new RegExp("\\/(?:true|false)\\/([0-9]+)\\/");
    this.idProduit = parseInt(regex.exec(this.router.url)[1]);
    this.initData();
  };

  private initData() {
    this.subPopularityHistory = this.produitSvc.getHistoryPopularity(this.idProduit, this.selectedDates).subscribe((res) => {
      if (res)
        this.popularityHistory = res.resultList;
    })
  }

  private initDate() {
    this.selectedDates = [this.getStartDate(), this.getEndDate()]
  }

  private getStartDate() {
    const date = new Date()
    date.setMonth(date.getMonth()-11)
    return date;
  }

  private getEndDate() {
    const date = new Date()
    date.setMonth(date.getMonth()+1)
    return date;
  }

  onValueChanged(dates) {
    let filteredDates: Date[];
    if (dates.value[0]) {
      const startDate = dates.value[0];
      let endDate: any;
      if (dates.value[1])
        endDate =  dates.value[1];
      else
        endDate = dates.value[0];
      filteredDates = [startDate, endDate]
    } else
      filteredDates = undefined
    this.selectedDates = filteredDates;
    this.initData();
  };
}
